/** A response header by name, whatever case the transport keyed it with. */
export function responseHeader(headers: unknown, name: string): string | undefined {
    if (!headers || typeof headers !== "object") return undefined;
    const wanted = name.toLowerCase();
    const entry = Object.entries(headers).find(([key]) => key.toLowerCase() === wanted);
    return entry?.[1] == null ? undefined : String(entry[1]);
}

/** The name a `Content-Disposition` header carries: the UTF-8 `filename*` first (ai_engine's
 *  `content_disposition` sends both), then the ASCII `filename`. */
export function contentDispositionFileName(header: string | undefined): string | undefined {
    if (!header) return undefined;
    const extended = /filename\*\s*=\s*UTF-8''([^;\s]+)/i.exec(header)?.[1];
    if (extended) {
        try {
            return decodeURIComponent(extended);
        } catch {
            // A malformed escape: the ASCII name below still names the file.
        }
    }
    const plain = /filename\s*=\s*(?:"([^"]*)"|([^;\s]+))/i.exec(header);
    return (plain?.[1] ?? plain?.[2]) || undefined;
}
